export const TAX_LEDGERS_RESET_STATE = 'TAX_LEDGERS_RESET_STATE';
export const TAX_LEDGERS_CURRENT_ITEM = 'TAX_LEDGERS_CURRENT_ITEM';

export const TAX_LEDGERS_REQUEST_LOADING = 'TAX_LEDGERS_REQUEST_LOADING';
export const TAX_LEDGERS_REQUEST_SUCCESS = 'TAX_LEDGERS_REQUEST_SUCCESS';
export const TAX_LEDGERS_REQUEST_FAILED = 'TAX_LEDGERS_REQUEST_FAILED';

export const TAX_LEDGERS_CURRENT_ACTION = 'TAX_LEDGERS_CURRENT_ACTION';
export const TAX_LEDGERS_RESET_ACTION = 'TAX_LEDGERS_RESET_ACTION';